<template>
  <div class="huawei">
    <div class="header">
      <p>
        {{ app.header.tip1 }}
      </p>
    </div>
    <div class="container">
      <div class="container-title">
        <div class="num">1</div>
        <div class="title-word">{{ app.content.list1.title }}</div>
      </div>
      <div class="content">
        <img src="../assets/huawei-1.png" alt="" />
        <img src="../assets/huawei-2.png" alt="" />
      </div>
      <div class="container-title">
        <div class="num">2</div>
        <div class="title-word">{{ app.content.list2.title }}</div>
      </div>
      <div class="content">
        <img src="../assets/huawei-3.png" alt="" />
      </div>
      <div class="container-title">
        <div class="num">3</div>
        <div class="title-word">
          {{ app.content.list3.title }}
        </div>
      </div>
      <div class="content">
        <img src="../assets/huawei-4.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import zh from "@/locales/huawei/zh";
import en from "@/locales/huawei/en";
import { toggleLang } from "@/mixins/toggleLang";
export default {
  name: "huawei",
  mixins: [toggleLang],
  created() {
    this.toggle(zh, en);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.header p {
  text-align: left;
  font-size: 42px;
  font-family: Source Han Sans CN;
}
.container-title {
  display: flex;
  margin-top: 65px;
}
.title-word {
  flex: 8;
  text-align: left;
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 60px;
  padding-left: 26px;
}
.num {
  width: 68px;
  height: 68px;
  line-height: 68px;
  border-radius: 50%;
  background-color: #30b29e;
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.content img:first-child {
  margin-top: 56px;
}
.content img {
  width: 100%;
}
.title-word p:nth-child(2) {
  margin-top: 30px;
}
</style>
